$(function () {
  //PAGE TRANSITION
  $('a:not([href^="http://"]):not([href^="https://"])')
    .not(".js-no-transition")
    .each(function () {
      $(this).addClass("js-transition-link");
    });
  //LOAD PAGE ONCE IMAGES HAVE LOADED
  $("body").imagesLoaded(function () {
    $("body").removeClass("transitioning");
  });

  //Add the highlight color
  $(".nav-link")
    .not(".js-cart-btn")
    .click(function () {
      $(".current").removeClass("current");
      $(this).addClass("current");
    });
  //Nav dropdown codes
  $(".nav-link").mouseenter(function () {
    $(".js-nav-dropdown, .nav-link, .scrim")
      .not(".js-cart-btn")
      .removeClass("is-active");
  });
  $(".js-nav-dropdown-link").mouseenter(function () {
    if ($("js-cart-dropdown").hasClass("is-active") == true) {
      return;
    }
    var dropdownName = $(this).attr("data-name");
    $(".is-active").removeClass("is-active");
    $("#" + dropdownName + ", .scrim").addClass("is-active");
    $(this).addClass("is-active");
  });
  $(".js-nav-dropdown").mouseleave(function () {
    $(".js-nav-dropdown, .nav-link, .scrim").removeClass("is-active");
  });
  // CHILD LINK HOVER EFFECT
  $(".child-nav-link, .footer-link").hover(
    function () {
      $(this).siblings().addClass("fade");
    },
    function () {
      $(".fade").removeClass("fade");
    }
  );
  //ADD INFO EXTRA HREF
  $(
    ".footer-links .footer-link, #info .child-nav-link, .mobile-link-info .mobile-child-nav-link"
  ).each(function () {
    var urlAdd = $(this).attr("data-name");
    var href = $(this).attr("href");
    $(this).attr("href", "" + href + "?" + urlAdd + "");
  });
  $("input.option-input").click(function () {
    $(this).siblings().prop("checked", false);
    $(this).prop("checked", true);
  });
});
// SCROLLING FUNCTIONS
$(document).scroll(function () {
  var scroll = $(document).scrollTop();
  var vh = $(window).height();
  var documentHeight = $(document).height();
  //FOOTER FADE
  if (scroll >= documentHeight - vh - 80) {
    $("body").addClass("dark");
    $(".is-active").removeClass("is-active");
    $("#shopify-section-header").addClass("no-need");
  } else {
    $("body").removeClass("dark");
    $("#shopify-section-header").removeClass("no-need");
  }
});

// ///////// //
// CART FORM //
// ///////// //
$(function () {
  let addToCartFormSelector = "#add-to-cart-form",
    productOptionSelector = addToCartFormSelector + " [name*=option]",
    currency = "£";

  let productForm = {
    onProductOptionChanged: function (event) {
      let $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      $form.trigger("form:change", [selectedVariant]);
    },
    getActiveVariant: function ($form) {
      let variants = JSON.parse(
          decodeURIComponent($form.attr("data-variants"))
        ),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null,
        },
        selectedVariant = null;

      $.each(formData, function (index, item) {
        if (item.name.indexOf("option") !== -1) {
          formOptions[item.name] = item.value;
        }
      });
      $.each(variants, function (index, variant) {
        if (
          variant.option1 === formOptions.option1 &&
          variant.option2 === formOptions.option2 &&
          variant.option3 === formOptions.option3
        ) {
          selectedVariant = variant;
          return false;
        }
      });
      return selectedVariant;
    },
    validate: function (event, selectedVariant) {
      let $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find(".js-variant-id"),
        $addToCartButton = $form.find("#add-to-cart-button"),
        $addToCartText = $addToCartButton.find("span"),
        $price = $form.find(".js-price"),
        $comparePrice = $form.find(".js-compare-price"),
        outOfStock = $addToCartButton.attr("data-oos"),
        addToCart = $addToCartButton.attr("data-addtocart"),
        formattedVariantPrice,
        formattedVariantComparePrice,
        priceHtml,
        comparePriceHtml,
        $imageChange = $(".js-product-image"),
        newImage;

      if (hasVariant) {
        formattedVariantPrice = currency + selectedVariant.price / 100;
        formattedVariantComparePrice =
          currency + selectedVariant.compare_at_price / 100;
        newImage = selectedVariant.featured_image;

        if (selectedVariant.price < selectedVariant.compare_at_price) {
          priceHtml =
            '<span class="new-price js-price">' +
            formattedVariantPrice +
            "</span>";
          comparePriceHtml =
            '<span class="old-price js-compare-price">' +
            formattedVariantComparePrice +
            "</span>";
          $(".js-sale-banner").removeClass("hidden");
        } else {
          priceHtml =
            '<span class="js-price">' + formattedVariantPrice + "</span>";
          comparePriceHtml = '<span class="old-price js-compare-price"></span>';
          $(".js-sale-banner").addClass("hidden");
        }
        if (selectedVariant.inventory_quantity == 0) {
          priceHtml =
            '<span class="soldout js-price">' + outOfStock + "</span>";
          $price.replaceWith(priceHtml);
          $addToCartText.text(outOfStock);
        }
        $price.replaceWith(priceHtml);
        $comparePrice.replaceWith(comparePriceHtml);
        if (newImage !== null) {
          $imageChange.attr("src", newImage.src);
          if ($(".mobile-product-images-container").css("display") == "block") {
            swiper.slideTo(1, 500, false);
          }
          if ($(".mobile-product-images-container").css("display") != "block") {
            $(document).scrollTop(0);
          }
        }
      }

      if (canAddToCart) {
        $addToCartText.text(addToCart);
        $id.val(selectedVariant.id);
        $addToCartButton.prop("disabled", false);
      } else {
        $id.val("");
        $addToCartButton.prop("disabled", true);
      }
    },
    init: function () {
      $(document).on(
        "change",
        productOptionSelector,
        productForm.onProductOptionChanged
      );
      $(document).on(
        "form:change",
        addToCartFormSelector,
        productForm.validate
      );
    },
  };
  productForm.init();
});

//TRANSITION FUNCTION
pageTransition = function (e) {
  $("body").addClass("t111ransitioning");
  $(".is-active").removeClass("is-active");
  $("body").removeClass("dark");
  $(".nav-open").removeClass("nav-open");
  e.preventDefault();
  var goTo = this.getAttribute("href");
  setTimeout(function () {
    window.location = goTo;
  }, 600);
};
//NAVIGATION FUNCTION
navigationOverlay = function () {
  $(".logo-container, nav").toggleClass("nav-open");
};

// /////////////
// CART CODES //
// /////////////

//CART DROP DOWN CODE
cartButtonDropdown = function (e) {
  e.preventDefault();
  $(".js-cart-dropdown, .cart-scrim, .js-cart-btn").toggleClass("is-active");
};
cartDropdown = function () {
  $(".js-cart-dropdown, .cart-scrim, .js-cart-btn").toggleClass("is-active");
};
(onAddToCart = function (e) {
  $(".js-add-to-cart-btn span").text("...");
  e.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: $("#add-to-cart-form").serialize(),
    dataType: "json",
    success: onAddToCartUpdated,
    error: onError,
  });
}),
  (onAddToCartUpdated = function () {
    $.ajax({
      type: "GET",
      url: "/cart",
      context: document.body,
      success: function (context) {
        let $addToCartButton = $(".js-add-to-cart-btn span"),
          buttonText = $(".js-add-to-cart-btn").attr("data-addtocart"),
          $dataCartContents = $(context).find(".js-cart-page-contents"),
          dataCartHtml = $dataCartContents.html(),
          dataCartItemCount = $dataCartContents.attr("data-cart-item-count");
        ($cartDropdownContents = $(".js-cart-dropdown-contents")),
          ($cartItemCount = $(".js-cart-item-count"));
        $cartItemCount.text(dataCartItemCount);
        $cartDropdownContents.html(dataCartHtml);
        cartDropdown();
        $addToCartButton.text(buttonText);
      },
    });
  }),
  (onCartUpdated = function () {
    $.ajax({
      type: "GET",
      url: "/cart",
      context: document.body,
      success: function (context) {
        let $dataCartContents = $(context).find(".js-cart-page-contents"),
          dataCartHtml = $dataCartContents.html(),
          dataCartItemCount = $dataCartContents.attr("data-cart-item-count");
        ($cartDropdownContents = $(".js-cart-dropdown-contents")),
          ($cartItemCount = $(".js-cart-item-count"));

        $cartItemCount.text(dataCartItemCount);
        $cartDropdownContents.html(dataCartHtml);
      },
    });
  }),
  (onLineRemoved = function (event) {
    event.preventDefault();
    $(this).text("...");
    let $removeLink = $(this),
      removeQuery = $removeLink.attr("href").split("change?")[1];
    $.post("/cart/change.js", removeQuery, onCartUpdated, "json");
  }),
  (onError = function (XMLHttpRequest, textStatus) {
    let data = XMLHttpRequest.responseJSON;
    alert(data.status + " - " + data.message + " - " + data.description);
  }),
  (updateLineItemQuantity = function (event) {
    let $quantityValue = $(this).val(),
      productID = $(this).attr("id");
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: productID,
        quantity: $quantityValue,
      },
      dataType: "json",
      success: onCartUpdated,
    });
  }),
  (itemLineQuantity = function () {
    let $quantityNumber = $(this).siblings(".js-quantity-input").val(),
      $displayNumber = $(this).siblings(".js-quantity-number").text(),
      productID = $(this).siblings(".js-quantity-input").attr("id");
    if ($(this).hasClass("js-quantity-plus")) {
      $quantityNumber++;
    }
    if ($(this).hasClass("js-quantity-minus")) {
      $quantityNumber--;
    }
    $(this).siblings(".js-quantity-number").text($quantityNumber);
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        id: productID,
        quantity: $quantityNumber,
      },
      dataType: "json",
      success: onCartUpdated,
    });
  });

$(document).on("submit", "#add-to-cart-form", onAddToCart);
$(document).on("click", ".cart-dropdown .js-remove-line", onLineRemoved);
$(document).on("click", ".js-cart-btn", cartButtonDropdown);
$(document).on("change", ".js-quantity-input", updateLineItemQuantity);
$(document).on("click", ".js-quantity-change", itemLineQuantity);

$(document).on("click", ".js-transition-link", pageTransition);

$(document).on("click", ".js-nav-btn", navigationOverlay);
